import Vue from 'vue'
import BaseService from './base.service'

class BaseHttpService extends BaseService {
  constructor (key = null) {
    super()
    this.__key = key || ''
  }

  static _http () {
    return Vue.prototype.$api
  }

  static _endpoints (key = null) {
    if (key) {
      return Vue.config.endpoints[key] || {}
    }
    return {}
  }

  static get (url, params, ...callbacks) {
    BaseHttpService._http().get(url, params, ...callbacks)
  }

  static post (url, data, ...callbacks) {
    BaseHttpService._http().post(url, data, ...callbacks)
  }

  static put (url, data, ...callbacks) {
    BaseHttpService._http().put(url, data, ...callbacks)
  }

  static patch (url, data, ...callbacks) {
    BaseHttpService._http().patch(url, data, ...callbacks)
  }

  static delete (url, ...callbacks) {
    BaseHttpService._http().delete(url, {}, ...callbacks)
  }
}

export default BaseHttpService
